import React from "react";

const Tabs = ({values, activeState, onClick, disabledTabs = false}) => {
  const data = values.split(',');
  return (
    <div className="tabSearch">
      <ul className="tabs">
        {data.map((item, index) => 
          <li key={index} className="tab" onClick={() => !disabledTabs ? onClick(item) : false}>
            <a className={activeState === item ? 'active' : ''}>{item}</a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Tabs;